var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderFactory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0882 5.27332L11.2362 5.5H11.5069H20C20.8284 5.5 21.5 6.17157 21.5 7V18C21.5 18.8284 20.8284 19.5 20 19.5H4C3.17157 19.5 2.5 18.8284 2.5 18V5C2.5 4.17157 3.17157 3.5 4 3.5H9.93058L11.0882 5.27332Z",
    fill: "#CDD0D4",
    stroke: "#74797D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0242 13.2341H10.4475V17H8.90332V8.11328H14.5491V9.3584H10.4475V12.0012H14.0242V13.2341Z",
    fill: "#74797D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFactory);
export default __webpack_public_path__ + "static/media/folder-factory.833e7f2edb629e6812b53483a83f5060.svg";
export { ForwardRef as ReactComponent };